import { LookupModelSearchEvent } from "@mcleod/components";
import { AutogenLayoutBillingRegisterReport } from "./autogen/AutogenLayoutBillingRegisterReport";

export class BillingRegisterReport extends AutogenLayoutBillingRegisterReport {
    override onLoad(): void {
        this.textboxD.selectedItem = this.textboxD.items[0];
        this.textboxReportType.selectedItem = this.textboxReportType.items[0];
    }

    dateTypeChanged() {
        const selectedItem = this.textboxD.text;
        if(selectedItem.startsWith("GL")) {
            this.textboxDateRange.caption = "GL Distribution Date(s)"
        }
        else if(selectedItem.startsWith("Ship")){
            this.textboxDateRange.caption = "Ship Date(s)"
        }
        else{
            this.textboxDateRange.caption = "Bill Date(s)"
        }
    }

    reportTypeChanged(){
        const reportType = this.textboxReportType.text;
        if(reportType.startsWith("Detailed")){
            this.switchGroupByCust.enabled = true;
        }
        else if(reportType.startsWith("Summary")){
            this.switchGroupByCust.enabled = false;
            this.switchGroupByCust.checked = true;
        }
        else {
            this.switchGroupByCust.checked = false;
            this.switchGroupByCust.enabled = false;
        }
    }

    textboxCustomersBeforeLookupModelSearch(event: LookupModelSearchEvent) {
        event.filter.is_active = "Y"
        event.filter.type_of = "C"
    }
}
